module.exports = __webpack_public_path__ + "img/9_112.dd08601e.png";